import { supabase } from '@/integrations/supabase/client';
import {
  getActionableApplicationUserIds,
  type ApplicationQueueBACandidate,
  type ApplicationQueueCandidate,
  type PromoterProfileCandidate,
} from '@/lib/applicationQueue';

const PAGE_SIZE = 1000;

export const fetchPendingApplicationsCount = async () => {
  const applications: ApplicationQueueCandidate[] = [];
  const bas: ApplicationQueueBACandidate[] = [];
  const profiles: PromoterProfileCandidate[] = [];

  for (let from = 0; ; from += PAGE_SIZE) {
    const { data, error } = await supabase
      .from('ba_applications')
      .select('user_id, status')
      .range(from, from + PAGE_SIZE - 1);

    if (error) throw error;
    applications.push(...(data || []));
    if (!data || data.length < PAGE_SIZE) break;
  }

  for (let from = 0; ; from += PAGE_SIZE) {
    const { data, error } = await supabase
      .from('bas')
      .select('user_id, status')
      .order('created_at', { ascending: false })
      .range(from, from + PAGE_SIZE - 1);

    if (error) throw error;
    bas.push(...(data || []));
    if (!data || data.length < PAGE_SIZE) break;
  }

  for (let from = 0; ; from += PAGE_SIZE) {
    const { data, error } = await supabase
      .from('profiles')
      .select('id, id_passport_number, cell_number, created_at')
      .order('created_at', { ascending: false })
      .range(from, from + PAGE_SIZE - 1);

    if (error) throw error;
    profiles.push(...(data || []));
    if (!data || data.length < PAGE_SIZE) break;
  }

  return getActionableApplicationUserIds({ applications, bas, profiles }).size;
};
